import { createSelector } from 'reselect'
import { pathOr } from 'ramda'
import isEmpty from 'lodash.isempty'
import { initialState } from './reducer'
import { getAccessTokenFromLocalStorage } from 'utils/storage'
import { isMobileWebview } from 'utils/utils'
import {
  selectIsGriddyGuest,
  selectEnrolledMembers,
  selectCurrentMember,
} from '../members/selectors'

export const selectUserState = state => state.user

export const makeSelectUserID = () =>
  createSelector(selectUserState, substate =>
    pathOr(initialState.userID, ['userID'], substate)
  )

export const selectName = createSelector(
  selectUserState,
  substate => `${substate.first_name} ${substate.last_name}`
)

export const selectFirstName = createSelector(
  selectUserState,
  substate => substate.first_name
)

export const selectLastName = createSelector(
  selectUserState,
  substate => substate.last_name
)

export const makeSelectEmail = () =>
  createSelector(selectUserState, substate =>
    pathOr(initialState.email, ['email'], substate)
  )

export const selectFormEmail = () =>
  createSelector(selectUserState, substate =>
    pathOr(initialState.formEmail, ['formEmail'], substate)
  )

export const selectMagicLinkSent = () =>
  createSelector(selectUserState, substate =>
    pathOr(initialState.magicLinkSent, ['magicLinkSent'], substate)
  )

export const selectLoginError = createSelector(
  selectUserState,
  substate => substate.error
)

export const selectPhone = createSelector(
  selectUserState,
  substate => substate.phone
)
export const selectEmail = createSelector(
  selectUserState,
  substate => substate.email
)
export const selectUserID = createSelector(
  selectUserState,
  substate => substate.userID
)
export const selectGGStatus = createSelector(
  selectUserState,
  substate => substate.gg_status
)

export const selectIsAuthenticated = createSelector(
  selectIsGriddyGuest,
  selectEnrolledMembers,
  selectCurrentMember,
  (isGriddyGuest, members, currentMember) =>
    isGriddyGuest ||
    (members.length > 0 && !isEmpty(currentMember)) ||
    (getAccessTokenFromLocalStorage() && isMobileWebview)
)

export default () => createSelector(selectUserState, substate => substate)
